var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",style:({ '--form-item-width': _vm.grid.Cols, '--form-item-height': _vm.grid.Rows, '--form-item-start': _vm.grid.Offset })},[(_vm.value)?_c('p',[_vm._v(_vm._s(_vm.value))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }